var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmationcheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 148,
    viewBox: "0 0 147 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_272_15075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73.4474,
    cy: 64,
    r: 46.631,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4474 41.7948C61.2123 41.7948 51.2422 51.7649 51.2422 64C51.2422 76.2351 61.2123 86.2053 73.4474 86.2053C85.6825 86.2053 95.6526 76.2351 95.6526 64C95.6526 51.7649 85.6825 41.7948 73.4474 41.7948ZM84.0615 58.8928L71.4712 71.4832C71.1603 71.7941 70.7384 71.9717 70.2943 71.9717C69.8502 71.9717 69.4283 71.7941 69.1174 71.4832L62.8333 65.1991C62.1894 64.5552 62.1894 63.4893 62.8333 62.8454C63.4773 62.2014 64.5431 62.2014 65.1871 62.8454L70.2943 67.9526L81.7078 56.5391C82.3517 55.8951 83.4176 55.8951 84.0615 56.5391C84.7055 57.183 84.7055 58.2267 84.0615 58.8928Z",
    fill: "#41D195"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_272_15075",
    x: 0.17013,
    y: 0.715096,
    width: 146.555,
    height: 146.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.99235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.3231
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_272_15075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_272_15075",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationcheck);
export default __webpack_public_path__ + "static/media/confirmationcheck.38456cd9c891c5736ee3cda01c807a06.svg";
export { ForwardRef as ReactComponent };